var _module_exports = "<div class=\"bg-light lter b-b wrapper-md\">\n  <h1 class=\"m-n font-thin h3\">COVID-19 closure</h1>\n  <small class=\"text-muted\">Quandoo Operation Center</small>\n</div>\n<div>\n  <div class=\"wrapper-md\">\n    <app-covid-19-closure></app-covid-19-closure>\n    <app-covid-19-reopening></app-covid-19-reopening>\n  </div>\n</div>\n";;
var path = '/app/ops-support/covid-19/covid-19.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/ops-support/covid-19/covid-19.template.html
// module id = 1036
// module chunks = 0